import { Card, Typography, Divider, Button } from "@mui/material";
import { NumberWithCommas } from "../controllers/utils";
import { Fragment } from "react";

// STYLING
import '../styles/Charge.scss';

// CHARGE
export default function Charge({ type, setCalculatorData, charge, isInCalculator, setShowNotification, setNotificationText }: ChargeProps) {
    const chargeNotes = charge.notes;

    // ADD CHARGE/VIOLATION TO CALCULATOR FUNCTION
    const AppendToCalculator = () => {
        setCalculatorData((prevCalculatorData: any) => {
            return [...prevCalculatorData, { index: Math.floor(Math.random() * 1000), ...charge }];
        });

        // NOTIFY
        setShowNotification(false);
        setTimeout(() => {
            setNotificationText(`[${charge.section}] ${charge.name} has been added to the calculator!`);
            setShowNotification(true);
        }, 250);
    }

    // REMOVE CHARGE/VIOLATION FROM CALCULATOR FUNCTION
    const RemoveFromCalculator = () => {
        const chargeIndex = charge.index;
        if (!isNaN(chargeIndex)) {
            setCalculatorData((prevCalculatorData: any) => {
                return prevCalculatorData.filter((thisCharge: any) => chargeIndex !== thisCharge.index);
            });

            // NOTIFY
            setShowNotification(false);
            setTimeout(() => {
                setNotificationText(`[${charge.section}] ${charge.name} has been removed from the calculator!`);
                setShowNotification(true);
            }, 250);
        }
    }

    // RETURN ELEMENT
    return (
        <Card variant="outlined" className={`charge ${type === 'charge' ? (charge.type).toLowerCase() : 'violation'}`} sx={{ py: 2, px: 3 }}>
            <Typography variant="h6" color="white" fontFamily="Public Sans" fontWeight={600} gutterBottom>
                [{charge.section}] {charge.name}
            </Typography>

            <Typography component="p" variant="subtitle1" color="darkgray" fontFamily="Public Sans" gutterBottom>
                {NumberWithCommas(type === 'charge' ? charge.months : charge.points)} {type === 'charge' ? 'months' : 'points'}  | ${NumberWithCommas(charge.fine)}
            </Typography>

            {/* CHARGE DESCRIPTION */}
            <Typography component="p" variant="subtitle2" color="white" fontFamily="Public Sans" sx={{ mt: 2 }}>
                {charge.description.split('<br>').map((line: string, index: number) => (
                    <Fragment key={index}>
                        {line}
                        <br />
                    </Fragment>
                ))}
            </Typography>

            {/* ADDITIONAL NOTES OF THE CHARGE */}
            {(chargeNotes && chargeNotes !== '') && 
                <>
                    <Divider sx={{ my: 2 }} />

                    <Typography component="p" variant="subtitle2" color="white" fontFamily="Public Sans" sx={{ mt: 2 }}>
                        {charge.notes.split('<br>').map((line: string, index: number) => (
                            <Fragment key={index}>
                                {line}
                                <br />
                            </Fragment>
                        ))}
                    </Typography>
                </>
            }

            {/* FINAL DIVIDER */}
            <Divider sx={{ my: 2 }} />

            {/* ADD CHARGE BUTTON */}
            <Button
                variant="outlined"
                aria-label={`${!isInCalculator ? 'Add' : 'Remove'} x1`}
                sx={{
                    '&:hover': {
                        color: 'var(--teal_brighter)',
                        borderColor: 'var(--teal_brighter)'
                    },
                    fontSize: 15,
                    fontFamily: 'Public Sans',
                    textTransform: 'none',
                    color: 'var(--teal)',
                    borderColor: 'var(--teal)'
                }}
                onClick={() => {
                    if (isInCalculator && !isNaN(charge.index)) {
                        RemoveFromCalculator();
                    } else {
                        AppendToCalculator();
                    }
                }}
            >
                {!isInCalculator ? 'Add' : 'Remove'} x1
            </Button>
        </Card>
    )
}
